import { render, staticRenderFns } from "./OrganizationField.vue?vue&type=template&id=268a252f&scoped=true"
import script from "./OrganizationField.vue?vue&type=script&lang=js"
export * from "./OrganizationField.vue?vue&type=script&lang=js"
import style0 from "./OrganizationField.vue?vue&type=style&index=0&id=268a252f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268a252f",
  null
  
)

export default component.exports